<template>
  <v-list-tile v-if="$route.name === 'classifier/predictions/items'">
    <!-- The text with the setting info -->
    <v-list-tile-content>
      <v-list-tile-title>Tamaño página: {{ itemsFetch }}</v-list-tile-title>
    </v-list-tile-content>
    <!-- The edit icon to open a dialog to edit it -->
    <v-list-tile-action>
      <v-dialog v-model="showingDialog" lazy width="500">
        <!-- The icon as activator of the dialog -->
        <template #activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon color="blue-grey">edit</v-icon>
          </v-btn>
        </template>
        <!-- The text field to edit the value -->
        <v-text-field
          v-model="editValue"
          append-icon="check_circle"
          autofocus
          @click:append="setValueAndCloseDialog"
          hide-details
          @keyup.enter="setValueAndCloseDialog"
          label="Tamaño página"
          solo
        />
      </v-dialog>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  data: () => ({
    editValue: null,
    showingDialog: false
  }),
  computed: {
    ...mapState(["itemsFetch"])
  },
  created() {
    this.editValue = this.itemsFetch;
  },
  methods: {
    ...mapMutations(["setItemsFetch"]),
    setValueAndCloseDialog() {
      this.setItemsFetch(this.editValue);
      this.showingDialog = false;
    }
  }
};
</script>